<template>
  <md-editor-v3 v-model="text" />
  <el-card class="question-card">
    <div class="q-header">
      <el-tag type="info">{{ q.typeName }}</el-tag>
      <el-tag type="success">{{ q.difficultName }}</el-tag>
      <el-tag>{{ q.gradeName }}</el-tag>
    </div>

    <md-editor preview-only preview-theme="github" v-model="q.content" style="text-align: left" />
    <!-- <div class="q-content" v-if="q.questionsImage">
      <img :src="q.questionsImage" alt="题目图" style="max-width:100%" />
    </div> -->
    <!-- <div class="q-content" v-html="q.content" /> -->
    <!-- <v-md-preview v-model="q.content" height="400px"></v-md-preview> -->
    <!-- <v-md-editor v-model="q.content" height="400px"></v-md-editor> -->

    <div class="q-options" v-if="q.options">
      <div v-for="opt in q.options" :key="opt.id">{{ opt.label }}. {{ opt.content }}</div>
    </div>

    <div class="q-actions">
      <el-button size="mini" @click="$emit('add-to-paper', q)">添加到组卷</el-button>
      <el-button size="mini" type="primary" plain @click="showListDialog = true">收藏至题单</el-button>
      <el-button size="mini" @click="showAns = !showAns">
        {{ showAns ? '隐藏答案' : '显示答案' }}
      </el-button>
    </div>

    <div class="q-answer" v-if="showAns">
      <strong>答案：</strong> {{ q.answer }}<br />
      <strong>解析：</strong> {{ q.explanation }}
    </div>

    <SelectListDialog v-model="showListDialog" :questionId="q.id" />
  </el-card>
</template>

<script setup>
import { ref, defineComponent } from 'vue'
import SelectListDialog from './SelectListDialog.vue'

const props = defineProps({ q: Object })
const emit = defineEmits(['add-to-paper'])
const showAns = ref(false)
const showListDialog = ref(false)

import MdEditor from 'md-editor-v3';
import 'md-editor-v3/lib/style.css';
const text = ref()

</script>

<style scoped>
.question-card {
  margin-bottom: 16px;
}

.q-header {
  margin-bottom: 8px;
}

.q-actions {
  margin-top: 12px;
}

.q-answer {
  margin-top: 8px;
  background: #fcf8e3;
  padding: 10px;
}

.q-content {
  margin: 8px 0;
}
</style>
